module.exports = __webpack_public_path__ + "static/media/formentor.0c69477f.jpg";